import { Button, Drawer, Modal, Steps, Table, Tooltip, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";

const MerchantPODetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [selectedDialogData, setSelectedDialogData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["pounsaverawproduct", "product"],
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: ["pounsaverawproduct", "description"],
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Unit",
      dataIndex: ["pounsaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "right",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p
          style={{ display: text.po_status === "preparing" ? "block" : "none" }}
        >
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedDialogData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  //   console.log("selectedData", selectedData);

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      po_number: selectedData !== null ? selectedData.po_number : "",
    };
    axios
      .get("user/commissary/spec-po-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInDelivery();
    }, 2000);
  };

  const handleDeleteProductInDelivery = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "id",
      selectedDialogData !== null ? selectedDialogData.id : ""
    );
    axios
      .post("user/commissary-employee/delete-product-in-saved-po", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            // setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoadings(false);
      });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Purchase Order Details"
      width={window.innerWidth > 710 ? 710 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <>
          <div
            style={{
              marginBottom: 10,
              border: "1px solid #e5e5e5",
              borderStyle: "dashed",
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 5,
              paddingRight: 5,
            }}
          >
            <Steps
              labelPlacement="vertical"
              size="small"
              direction={window.innerWidth > 710 ? "horizontal" : "vertical"}
              items={[
                {
                  title: "Acknowledge",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].acknowledge_datetime !== null
                      ? "finish"
                      : "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "Preparing",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].preparing_datetime !== null
                      ? "finish"
                      : orderDetailsList.data.length > 0 &&
                        orderDetailsList.data[0].acknowledge_datetime !== null
                      ? "process"
                      : "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "Ready",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].ready_datetime !== null
                      ? "finish"
                      : orderDetailsList.data.length > 0 &&
                        orderDetailsList.data[0].preparing_datetime !== null
                      ? "process"
                      : "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "In-Transit",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].intransit_datetime !== null
                      ? "finish"
                      : orderDetailsList.data.length > 0 &&
                        orderDetailsList.data[0].ready_datetime !== null
                      ? "process"
                      : "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "Arrived",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].arrived_datetime !== null
                      ? "finish"
                      : orderDetailsList.data.length > 0 &&
                        orderDetailsList.data[0].intransit_datetime !== null
                      ? "process"
                      : "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "Complete",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].complete_datetime !== null
                      ? "finish"
                      : orderDetailsList.data.length > 0 &&
                        orderDetailsList.data[0].arrived_datetime !== null
                      ? "process"
                      : "wait",

                  // "wait"
                  // icon: <DeleteOutlined />,
                },
              ]}
            />
          </div>

          {/* <div style={{ marginBottom: 10 }}>
            
          </div> */}

          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            {displayDetailsPrint && (
              <Typography.Title level={4} style={{ marginBottom: 15 }}>
                {selectedData.po_number} - Purchase Order
              </Typography.Title>
            )}
            <Typography>
              <span style={{ fontSize: 12 }}>Acknowledge by: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].acknowledge_by !== null
                  ? `${orderDetailsList.data[0].rawprodpocomemployee.firstname} ${orderDetailsList.data[0].rawprodpocomemployee.lastname}`
                  : "Commissary"}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Acknowledge date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].acknowledge_datetime !== null
                  ? moment(
                      new Date(orderDetailsList.data[0].acknowledge_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Prepared date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].preparing_datetime !== null
                  ? moment(
                      new Date(orderDetailsList.data[0].preparing_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Ready date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].ready_datetime !== null
                  ? moment(
                      new Date(orderDetailsList.data[0].ready_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>In-Transit date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].intransit_datetime
                  ? moment(
                      new Date(orderDetailsList.data[0].intransit_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Arrived date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].arrived_datetime
                  ? moment(
                      new Date(orderDetailsList.data[0].arrived_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Completed date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].complete_datetime
                  ? moment(
                      new Date(orderDetailsList.data[0].complete_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Table
              {...tableProps}
              // pagination={{
              //   position: ["bottomRight"],
              // }}
              pagination={false}
              columns={tableColumns}
              dataSource={
                orderDetailsList.data.length > 0 ? orderDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.raw_id}
            />
          </div>
        </>
      )}

      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ flexGrow: 1 }} />
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      </div>

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
      />
    </Drawer>
  );
};

export default MerchantPODetails;
